import React from 'react'
import { Markup } from 'interweave'
import { useTranslation } from 'react-i18next'
import ArrowDown from '../assets/svg/arrow-down.svg'

const QuestionCard = ({ title, desc }: { title: string; desc: string }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <div
      style={{
        background: isOpen ? '#F0F3F6' : '#fff',
      }}
      className='w-full flex-1 mb-6 transition ease-in-out duration-500 border-gray-200 border'
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            setIsOpen(!isOpen)
          }
        }}
        className='flex p-6 flex-row justify-between items-center cursor-pointer'
        role='button'
        tabIndex={0}
      >
        <div className='sm:text-[24px] text-[16px] w-11/12'>{title}</div>
        <div className='cursor-pointer w-1/12 items-end justify-end flex '>
          <img
            src={ArrowDown}
            alt='Arrow-down'
            className='ease-in duration-200 '
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </div>
      </div>
      {isOpen && (
        <div className='px-6 pb-4'>
          <Markup className='mt-4 duration-500 sm:text-[16px] text-[14px] ' content={desc} />
        </div>
      )}
    </div>
  )
}
const QuestionBlock = (array: any, translation?: string) => {
  const { t } = useTranslation()

  return array?.map(
    (
      item: {
        title: string
        description: string
      },
      index: number,
    ) => (
      <QuestionCard
        key={`${index + 1}/${item.title}`}
        title={
          translation
            ? t(`p2p-page.${translation}.questionBlock.question${index + 1}`)
            : t(`${item.title}`)
        }
        desc={
          translation
            ? t(`p2p-page.${translation}.questionBlock.Answer${index + 1}`)
            : t(`${item.description}`)
        }
      />
    ),
  )
}

export default QuestionBlock
